import { create } from 'zustand';

type RequireSubscriptionSheetState = {
    isOpen: boolean;
    openDrawer: () => void;
    closeDrawer: () => void;
    toggleDrawer: () => void;
};

export const useRequireSubscriptionSheetStore = create<RequireSubscriptionSheetState>((set) => ({
    isOpen: true,
    openDrawer: () => set({ isOpen: true }),
    closeDrawer: () => set({ isOpen: false }),
    toggleDrawer: () => set((state) => ({ isOpen: !state.isOpen }))
}));

